"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentRequestStatusGraphDefaultAttributes = exports.PaymentRequestStatusAttributes = exports.PaymentRequestStatus = void 0;
var PaymentRequestStatus;
(function (PaymentRequestStatus) {
    PaymentRequestStatus["WAITING_FOR_INVOICE"] = "WAITING_FOR_INVOICE";
    PaymentRequestStatus["INVOICE_ISSUED"] = "INVOICE_ISSUED";
    PaymentRequestStatus["INVOICE_SENT"] = "INVOICE_SENT";
    PaymentRequestStatus["PAID"] = "PAID";
})(PaymentRequestStatus = exports.PaymentRequestStatus || (exports.PaymentRequestStatus = {}));
exports.PaymentRequestStatusAttributes = {
    [PaymentRequestStatus.WAITING_FOR_INVOICE]: {
        name: 'Aguardando Emissão de Nota Fiscal',
        is_final: false,
        allow_input_insertion: true,
    },
    [PaymentRequestStatus.INVOICE_ISSUED]: {
        name: 'Nota Fiscal Emitida',
        is_final: false,
    },
    [PaymentRequestStatus.INVOICE_SENT]: {
        name: 'Nota Fiscal Enviada',
        is_final: false,
    },
    [PaymentRequestStatus.PAID]: {
        name: 'Pago',
        is_final: true,
    },
};
exports.paymentRequestStatusGraphDefaultAttributes = {
    version: '1.0',
    initial_status: PaymentRequestStatus.WAITING_FOR_INVOICE,
};
